import home from './music-library-removebg-preview.png';
import artist from './james-brown-removebg-preview.png';
import song from './music-record-removebg-preview.png';
import topchart from './radio-removebg-preview.png';
import country from './globe-removebg-preview.png';

export default {
  home,
  artist,
  song,
  topchart,
  country,
};
